export default __webpack_public_path__ + "static/WebSite_3DShowcaseGhostprint_VideoQHD-5e9921b7a885f0b0a3eddad056dd2817.mp4";